import React from 'react';

interface FishIQShellProps {
  children: React.ReactNode;
}

const FishIQShell: React.FC<FishIQShellProps> = ({ children }) => {
  return <>{children}</>;
};

export default FishIQShell;
